import { keyframes, styled } from '@components-shared/src/stitches';

export const TimeLabel = styled('div', {
  padding: '3px 5px',
  letterSpacing: '0.04em',
  borderRadius: 4,
  backgroundColor: '#000',
  base: 'S',
  lineHeight: '14px',
  color: '$neutral100',
  fontWeight: 500,

  position: 'absolute',
  top: 54,
  '@tablet': {
    top: 48,
  },

  variants: {
    side: {
      right: {
        right: '5px',
        '@tablet': {
          right: '15px',
        },
      },
    },
  },
});

export const DisplayDateText = styled('p', {
  position: 'absolute',
  margin: '0.5rem',
  right: 0,
  padding: '7px 12px 5px',
  color: '$grey900',
  borderRadius: '16px',
  fontSize: '12px',
  background: '$white',
  lineHeight: 1,
  whiteSpace: 'nowrap',
  userSelect: 'none',
});

export const WaveFormCommentsContainer = styled('div', {
  display: 'flex',
  align: 'start',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  width: '100%',
});

const expand = keyframes({
  '0%': {
    transform: 'scaleX(0)',
  },
  '100%': {
    transform: 'scaleX(1)',
  },
});

export const WaveformPlaceholder = styled('div', {
  animationDuration: '1000ms',
  animationFillMode: 'forwards',
  animationName: `${expand}`,
  animationTimingFunction: 'ease-in',
  height: 1,
  width: '100%',
  position: 'absolute',
  top: '60%',
  backgroundColor: '$grey300',
  zIndex: '$below',
});
